@import '../../../../../../constants/spacing.module.less';

.plan-grid-tabs {
  width: 100%;
}

.tab-list {
  border-bottom: none;
}

// Base tab panel styles
.tab-panel {
  border-top-right-radius: 8px;
}

.tab-panel-not-first {
  border-top-left-radius: 8px;
}

.no-section-border-top {
  border-top: none;
  border-top-left-radius: 8px;
}

.promo-icon {
  color: var(--purple-8D30F7);
  height: 12px;
  align-self: center;
}
